var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Fingerprint2 from 'fingerprintjs2';
const generateFingerPrint = () => __awaiter(void 0, void 0, void 0, function* () {
    const options = {
        excludes: {
            adBlock: true,
            fonts: true,
            enumerateDevices: true,
            pixelRatio: true,
        },
    };
    const fingerPrintComponents = yield new Promise(resolve => {
        if (window.requestIdleCallback) {
            window.requestIdleCallback(() => {
                Fingerprint2.get(options, components => {
                    resolve(components);
                });
            });
        }
        else {
            window.setTimeout(() => {
                Fingerprint2.get(options, components => {
                    resolve(components);
                });
            }, 500);
        }
    });
    return Fingerprint2.x64hash128(fingerPrintComponents.flatMap(component => component.value).join(''), 31);
});
export default generateFingerPrint;
//# sourceMappingURL=generateFingerPrint.js.map